import { generateEndpoint } from '@ngtrvu/use-api';
import { createApiCall } from 'lib/base';

const GET_USER_DETAIL = 'GET_USER_DETAIL';

const apiCall = createApiCall(
  GET_USER_DETAIL,
  ({ id, ...params }: { id: string; params: any }) => ({
    endpoint: generateEndpoint({
      host: `api/admin/users/${id}`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
